const SAMPLE_WIDTH = /^w-\[[^\]]+\]$/

/**
 * Drops the arbitrary width a Figma contract cell carries from its sample frame
 * (`w-[19.5rem]`), so the component sizes to its container instead.
 */
export const withoutSampleWidth = (classes: string): string =>
    classes
        .split(' ')
        .filter(item => !SAMPLE_WIDTH.test(item))
        .join(' ')
